import { Feature } from "interface/Feature"
import defaultFeatBgImage from 'assets/images/svg/graph-background-feature.svg'
import featureImage from 'assets/images/png/feature-data-visualization.png'
import featureIcon from '@iconify-icons/solar/pie-chart-3-line-duotone'

/**
 * Workspace feature object.
 * 
 * @type {Feature}
 * @property {IconifyIcon} icon - The icon for the feature, using the Iconify icon.
 * @property {boolean} isIcon - Determines whether the feature uses an icon.
 * @property {string} iconWrapperBgColor - Background color of the icon wrapper.
 * @property {string} featureImage - The path to the image that will be displayed.
 * @property {string} hoverBackgroundImage - Background image that appears on hover.
 * @property {string} hoverBackground - The gradient background applied on hover.
 * @property {string} title - The title of the feature (Data Visualization).
 * @property {string} description - The description of the feature, explaining its purpose.
 * @property {string} defaultColor - Default color for the icon or text.
 * @property {string} hoverColor - Color applied when the feature is hovered.
 * @param {string} [specialText] - Optional text that can be used to highlight the feature (e.g., "New").
 * @property {string} link - The URL or path to navigate to when the feature is clicked.
 */
export const workspaceFeat : Feature = {
    icon: featureIcon,
    isIcon: true,
    iconWrapperBgColor: '#FFFBFA',
    featureImage: featureImage,
    hoverBackgroundImage: defaultFeatBgImage,
    hoverBackground: "linear-gradient(224.8deg, #fff, #d1efff)",
    title: 'Workspace',
    description: "Explore African markets with Zerone’s private canvas. Filter variables, gain insights, and build AI-powered visual reports in seconds.",
    defaultColor: '#707070',
    hoverColor: '#FF5522',
    link: '/workspace',
}